import { render } from "./indicadores-administracion.vue?vue&type=template&id=6be0b7b1"
import script from "./indicadores-administracion.vue?vue&type=script&lang=js"
export * from "./indicadores-administracion.vue?vue&type=script&lang=js"

import "./indicadores-administracion.vue?vue&type=style&index=0&id=6be0b7b1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__